import { observable } from 'mobx'

class QuestionWeight {
    constructor({
        questionId,
        adjustment,
        value,
    }) {
        this.kind = 'question'
        this.questionId = questionId
            ? questionId.toUpperCase()
            : undefined
        this.adjustment = adjustment
        this.value = value
    }

    toJSON() {
        return {
            kind: this.kind,
            questionId: this.questionId,
            adjustment: this.adjustment,
            value: Number(this.value),
        }
    }
}

export default QuestionWeight
